import ResizeObserver from 'resize-observer-polyfill'
import { get, find } from 'lodash'
import { routes } from '../router'

export default {
  props: {
    socialMode: {
      type: Boolean
    },
    height: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      mounted: false
    }
  },
  async mounted () {
    // Emit a "resize" event when the componet element is resized
    const resizeObserver = new ResizeObserver(() => this.$emit('resize'))
    // Update the mounted attribute after the first tick
    this.mounted = !!await this.$nextTick()
    // Bind the resize observer to the component element. This cannot be done
    // before the first tick since the element doesn't exist yet in the DOM
    resizeObserver.observe(this.$el)
  },
  computed: {
    chartRoute () {
      return find(routes, route => {
        return get(route, 'chart.name') === get(this, '$options.name')
      })
    },
    chartSelectors () {
      return [
        '.column-chart',
        '.stacked-column-chart',
        '.stacked-bar-chart',
        '.bar-chart',
        '.line-chart',
        '.searchable-table'
      ]
    },
    chartHeight: {
      cache: false,
      get () {
        if (!this.mounted) {
          return 0
        }
        const element = this.$el.querySelector(this.chartSelectors.join(', '))
        return element?.getBoundingClientRect().height || 0
      }
    },
    fixedHeight: {
      cache: false,
      get () {
        if (!this.mounted || !this.height) {
          return null
        }
        const otherElementsHeight = Math.max(0, this.$el.offsetHeight - this.chartHeight)
        return this.height - otherElementsHeight
      }
    }
  }
}
